// Application interactions only: no counter IDs, goal names or user content.
export type AnalyticsOnboardingVariant = 'quiz' | 'no_quiz'
export type AnalyticsOnboardingStep = 1 | 2 | 3
export type AnalyticsEvent =
  | [interaction: 'quizStarted' | 'quizCompleted' | 'messageAccepted' | 'sosClicked' | 'journeyViewed' | 'tasksViewed' | 'pricingViewed']
  | [interaction: 'onboardingStarted' | 'onboardingCompleted', context: { variant: AnalyticsOnboardingVariant }]
  | [interaction: 'onboardingStepViewed', context: { variant: AnalyticsOnboardingVariant; step: AnalyticsOnboardingStep }]
  | [interaction: 'paymentOpened', context: { planId: string }]
export type AnalyticsInteraction = AnalyticsEvent[0]

export interface AnalyticsAdapter {
  track(...event: AnalyticsEvent): boolean
  screen(path: string, product: string): void
  paywallViewed(reason: string): void
}

let adapter: AnalyticsAdapter | undefined

// The application installs one adapter before rendering; this is not an event bus.
export function configureAnalytics(next: AnalyticsAdapter): void {
  adapter = next
}

export const analytics: AnalyticsAdapter = {
  track(...event) {
    try { return adapter?.track(...event) ?? false } catch { return false }
  },
  screen(path, product) {
    try { adapter?.screen(path, product) } catch { /* analytics must not interrupt navigation */ }
  },
  paywallViewed(reason) {
    try { adapter?.paywallViewed(reason) } catch { /* analytics must not interrupt the purchase flow */ }
  },
}
